export const listingConfigDrawer = {
  close: `إغلاق`,
  componentUnavailable: `المكوّن غير متاح.`,
};
